import React from 'react';
import { formatWorkingHours } from '../utils/workingHours';
import BottomSheet from './BottomSheet';

const WorkingHoursModal = ({ isOpen, onClose, workingHours, placeName }) => {
  const formattedHours = formatWorkingHours(workingHours);

  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      title="График работы"
      subtitle={placeName || undefined}
    >
      <div className="space-y-3">
        {formattedHours.map(({ day, dayName, isToday, isClosed, hours }) => (
          <div
            key={day}
            className={`flex justify-between items-center py-2 ${
              isToday ? 'bg-theme-bg-secondary px-3 rounded-md' : ''
            }`}
          >
            <span
              className={`text-body-sm ${
                isToday
                  ? 'font-semibold text-theme-text-primary'
                  : 'text-theme-text-secondary'
              }`}
            >
              {dayName}
              {isToday && (
                <span className="ml-2 text-caption text-action-text font-normal">
                  (сегодня)
                </span>
              )}
            </span>
            <span
              className={`text-body-sm tabular ${isToday ? 'font-semibold' : ''} ${
                isClosed ? 'text-danger' : 'text-theme-text-secondary'
              }`}
            >
              {hours}
            </span>
          </div>
        ))}
      </div>

      <p className="text-caption text-theme-text-hint mt-4 text-center">
        График работы не учитывает праздничные дни
      </p>
    </BottomSheet>
  );
};

export default WorkingHoursModal;
